/**
 * Shopify Ajaxify Shop. 
 * 
 * @uses Modified Shopify jQuery API (link to it)
 *
 */ 
 // Binding events every time when open modal window with cart
var  bindEventsInCarts = function(){
   

  $(".cart_product_flex").on("click",".remove_product_button", function(e){
    e.preventDefault();

    var el = $(this),
        id = el.data('id') || null;

    Shopify.removeItem(id, function(cart){
      Shopify.updateQuickCart(cart);
    });
  });

  /////////////////////////////////////
  // Qty for cart modal
  /////////////////////////////////////
  jQuery(".cart_product_flex").on("click", ".minus_btn", function () {
    var inputEl = jQuery(this).parent().find("input");
    var qty = inputEl.val();
    if (jQuery(this).parent().hasClass("minus_btn"))
      qty++;
    else
      qty--;
    if (qty < 0)
      qty = 0;
    inputEl.val(qty);

    var quantity = qty,
        id = inputEl.data("id");
    if(quantity != 0){
      Shopify.changeItem(id, quantity, function(cart){
        Shopify.updateQuickCart(cart);
      });
    }
    else{
      Shopify.removeItem(id, function(cart){
        Shopify.updateQuickCart(cart);
      });
    }
  })


  jQuery(".cart_product_flex").on("click",".plus_btn", function () {
    var inputEl = jQuery(this).parent().find("input");
    var qty = inputEl.val();

    if (jQuery(this).hasClass("plus_btn"))
      qty++;
    else
      qty--;
    if (qty < 0)
      qty = 0;


    var quantity = qty,
        id = inputEl.data("id");


    Shopify.changeItem(id, quantity, function(cart){
      var updatedItem = cart.items.filter(function(item){ return item.variant_id == id });
      if(updatedItem.length && updatedItem[0].quantity == quantity){
        Shopify.updateQuickCart(cart);
        inputEl.val(quantity);
      }
      else{
        jQuery('.ajaxcart__item__' + id + '__errors').show().delay(2000).fadeOut();
      }
    });

  });
}

jQuery(document).ready(function() {  

  var jQ = jQuery;
 
  var selectors = {
    // Any elements(s) with this selector will have the total item count put there on add to cart.
    TOTAL_ITEMS: '.count',
    QUICK_CART_MENU: 'div.cart_popup'
  }; 

    

 
  
  
  Shopify.addImageSize = function(src,size){
    if(typeof size === 'undefined'){ return src; }
    if(src === null){ return "\/\/www.sakertool.co.uk\/cdn\/shop\/t\/38\/assets\/no-image.gif?v=13552455658106495141701487598" }
    size = '_' + size + '.';
    return src.replace(/.([^.]*)$/,size+'$1');
  };
  
   Shopify.updateQuickCart = function(cart){
    console.log("ssss");
    var t = jQ(selectors.QUICK_CART_MENU);
    if(t.length){ 
      if(cart.items.length){

        var toAppend = [];

        for (var i = 0; i < cart.items.length; i++) {
          var itemPrice = cart.items[i].price, 
               totalPrice = cart.total_price,
            linePrice = cart.items[i].line_price,
              title = cart.items[i].variant_title;
				    
           
              
        

		if(title == null){
            title = "";
          }
		  var itemPriceConverted = Shopify.formatMoney(itemPrice,app.data.money_format),  
              totalPriceConverted = Shopify.formatMoney(totalPrice,app.data.money_format); 
          
		 var row = '<div class="cart_product_flex"><div class="cart_product_thum"><a href="' + cart.items[i].url + 
               '"><img class="img-responsive" src="' + Shopify.addImageSize(cart.items[i].image,'small') + '"alt="' + cart.items[i].title + 
			    '"></a></div><div class="cart_product_detail"><div class="cart_product_name"><h5><a href="' +  cart.items[i].url + 
				'" class="item-name">' + cart.items[i].product_title + 
				'</a></h5><p class="product-type">' + title + '</p></div><div class="cart_product_price"><p>Price: </p><span class="price money">'+itemPriceConverted+
				'</span></div><div class="cart_product_qty"><a class="minus_btn"></a><input type="text" class="txtbox"  id="updates_'+cart.items[i].id+'" data-id="'+cart.items[i].id+'" value="'+cart.items[i].quantity+'" /><a class="plus_btn"></a></div>'+'<a href="#" data-id="'+cart.items[i].id+'" class="remove_product_button">x</a></div></div>' 
              toAppend.push(row);
		  
		   

    var checkoutRow = t.find('div.cart_product');
     var subtotalRow = t.find('span.cart_total_price');
        if(checkoutRow.length){ /* we have existing items in the quick cart */
             subtotalRow.html(totalPriceConverted);
            t.find('div.cart_product').html(toAppend.join(''));
        }
    else{
      var addcartproduct='<div class="cart_product"></div>';
      var subtotalRow = '<div class="cart_popup_total_row clearfix"><span class="cart_total_val">Subtotal:</span><span class="cart_total_price">'+totalPriceConverted+'</span><span class="cart-notes">Free Shipping Over £29.99</span></div>';
      var addCheckOutBlock = '<div class="cart_popup_row"><button type="submit" name="checkout" value="CHECKOUT" class="cart_popup_checkout " >CHECKOUT</button><a class="cart_popup_cart" href="/cart">View Cart</a></div>';
 
          var form = jQ('<form />',{
            'action':'/cart',
            'method':'post',
            'novalidate':'novalidate'
          });
      jQuery('.cart_product-empty').hide();
        form.append(addcartproduct); 
          form.find("div.cart_product").html(toAppend.join(''));  
       form.append(subtotalRow);
          form.append(addCheckOutBlock); 
          t.append(form);
   
        }
 
          
		}
	 }
          else{
            
        t.html('<div class="cart_popup_title clearfix"><h4>My Order</h4> </div><div class="cart_product-empty"><div class="empty-cart">Your cart is currently empty.</div><p><a href="javascript:void(0)" class="btn_c btn_close">Continue Shopping</a></p></div>'); 
        
       } 
      
 } 
        Shopify.onCartUpdate(cart);    
         bindEventsInCarts();
 };
  
      Shopify.onCartUpdate = function(cart, form) {

        // Total Items Update
        var message = cart.item_count;
        if(cart.item_count > 0){
          jQ(selectors.TOTAL_ITEMS).text(message).removeClass('hidden');
        }else{
          jQ(selectors.TOTAL_ITEMS).text('').addClass('hidden');
        }
      }; 


   jQuery(".cart_product_flex").on("click",".plus_btn", function () {
        var inputEl = jQuery(this).parent().find("input");
        var qty = inputEl.val();

        if (jQuery(this).hasClass("plus_btn"))
          qty++;
        else
          qty--;
        if (qty < 0)
          qty = 0;
 
        var quantity = qty,
            id = inputEl.data("id");

        Shopify.changeItem(id, quantity, function(cart){
          var updatedItem = cart.items.filter(function(item){ return item.variant_id == id });
          if(updatedItem.length && updatedItem[0].quantity == quantity){
            Shopify.updateQuickCart(cart);
            inputEl.val(quantity);
          }
          else{
            jQuery('.ajaxcart__item__' + id + '__errors').show().delay(3000).fadeOut();
          }
        });

      })

      jQuery(".cart_product_flex").on("click", ".minus_btn", function () {
        var inputEl = jQuery(this).parent().find("input");
        var qty = inputEl.val();
        if (jQuery(this).parent().hasClass("minus_btn"))
          qty++;
        else
          qty--;
        if (qty < 0)
          qty = 0;
        inputEl.val(qty);
 
        var quantity = qty,
            id = inputEl.data("id");
        if(quantity != 0){
          Shopify.changeItem(id, quantity, function(cart){
            Shopify.updateQuickCart(cart);
          });
        }
        else{
          Shopify.removeItem(id, function(cart){
            Shopify.updateQuickCart(cart);
          });
        }
      });

      $(".cart_product_flex").on("click",".remove_product_button", function(e){
        e.preventDefault();
 
        var el = $(this),
            id = el.data('id') || null;
       
        Shopify.removeItem(id, function(cart){
          Shopify.updateQuickCart(cart);
        });
      });

  
    });

